document.addEventListener('DOMContentLoaded', function () {
    const marqueeSliderTop = document.querySelector('.static-marquee__top');
    const marqueeSliderBottom = document.querySelector('.static-marquee__bottom');
  
    let speedTop = 0.2;
    let positionTop = 0;
    marqueeSliderTop.innerHTML += marqueeSliderTop.innerHTML;
  
    function scrollMarqueeTop() {
      positionTop -= speedTop;
      if (Math.abs(positionTop) >= marqueeSliderTop.scrollWidth / 2) {
        positionTop = 0;
      }
      marqueeSliderTop.style.transform = `translateX(${positionTop}px)`;
      requestAnimationFrame(scrollMarqueeTop);
    }
  
    scrollMarqueeTop();
    marqueeSliderTop.addEventListener('mouseover', () => (speedTop = 0));
    marqueeSliderTop.addEventListener('mouseout', () => (speedTop = 0.2));
  
    let speedBottom = 0.2;
    let positionBottom = marqueeSliderBottom.scrollWidth / 2;
    marqueeSliderBottom.innerHTML += marqueeSliderBottom.innerHTML;
  
    function scrollMarqueeBottom() {
      positionBottom += speedBottom;
      if (positionBottom >= 0) {
        positionBottom = -marqueeSliderBottom.scrollWidth / 2;
      }
      marqueeSliderBottom.style.transform = `translateX(${positionBottom}px)`;
      requestAnimationFrame(scrollMarqueeBottom);
    }
  
    scrollMarqueeBottom();
    marqueeSliderBottom.addEventListener('mouseover', () => (speedBottom = 0));
    marqueeSliderBottom.addEventListener('mouseout', () => (speedBottom = 0.2));
  });